<template>
  <div class="row">

    <ibox>
      <template slot="title">通知テンプレート一覧</template>
      <div slot="body">

        <div class="forum-title">
          <h3>自動配信メール</h3>
        </div>

        <template v-for="notice in  mails">
          <div class="forum-item active">
            <div class="row">
              <div class="col-md-12">
                <div class="forum-icon">
                  <i class="fa fa fa-star"></i>
                </div>
                <router-link :to="'/notice/edit/'+notice.alias" class="forum-item-title">{{notice.name}}</router-link>
                <div class="forum-sub-title" v-html="notice.note">
                </div>
                <br>
              </div>
            </div>
          </div>
        </template>

      </div>
      <div slot="footer">

      </div>
    </ibox>
  </div>
</template>

<script>
  import Api from '../../service/Api.vue'

  export default {
    data () {
      return {
        mails: [],
        errors: false
      }
    },
    created: function () {
      this.init()
    },
    methods: {
      init: function () {
        Api.notice.search().then(this.resultInit).catch(this.resultInit)
      },
      resultInit: function (result) {
        if (!result.data) {
          this.errors = [['API接続に失敗しました。']]
          return
        }
        this.mails = result.data.mails
      }
    }
  }
</script>



// WEBPACK FOOTER //
// List.vue?3eb3d94d